import { IAbcComponent } from '../abcComponent.model';
export interface IForm extends IAbcComponent {
  caption?: string;
  itemType?: ItemType;
  formData?: any;
  visible?: boolean;
  activeStateEnabled?: boolean;
  alignItemLabels?: boolean;
  disabled?: boolean;
  hoverStateEnabled?: boolean;
  labelLocation?: LabelLocation;
  minColWidth?: number;
  showOptionalMark?: boolean;
  optionalMark?: string;
  readOnly?: boolean;
  requiredMark?: string;
  requiredMessage?: string;
  showRequiredMark?: boolean;
  rtlEnabled?: boolean;
  scrollingEnabled?: boolean;
  showColonAfterLabel?: boolean;
  showValidationSummary?: boolean;
  tabIndex?: number;

  setFormStyle(style?: FormStyle);
}

export enum ItemType {
  Empty = 'empty',
  Group = 'group',
  Simple = 'simple',
  Tabbed = 'tabbed',
  Button = 'button',
}

export class FormStyle {
  height: string | number = 25;
  width: string | number = '100%';
}

export enum LabelLocation {
  Left = 'left',
  Right = 'right',
  Top = 'top',
}
